export default __webpack_public_path__ + "86b5204d43be1af099f741008c6c8890.png";